import { render, staticRenderFns } from "./ConversationLinkWrapper.vue?vue&type=template&id=20582b9f&scoped=true"
import script from "./ConversationLinkWrapper.vue?vue&type=script&lang=js"
export * from "./ConversationLinkWrapper.vue?vue&type=script&lang=js"
import style0 from "./ConversationLinkWrapper.vue?vue&type=style&index=0&id=20582b9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20582b9f",
  null
  
)

export default component.exports